import {
    SEND_VERIFICATION_SMS_START,
    SEND_VERIFICATION_SMS_SUCCESS,
    SEND_VERIFICATION_SMS_ERROR
} from '../../constants';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { openHeaderModal } from '../siteadmin/modalActions';
import { sendVerificationSecureSms as mutation } from '../../lib/graphql';

export function sendVerificationSms({ phoneDialCode, phoneNumber, userType, isResendOtp, jwtToken }) {

    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: SEND_VERIFICATION_SMS_START,
            });
            if (!navigator.onLine) {
                showToaster({ messageId: 'networkFailed', toasterType: 'error' })
                return;
            }
            dispatch(setLoaderStart('smsLoading'));

            const { data } = await client.mutate({
                mutation,
                variables: {
                    phoneDialCode,
                    phoneNumber,
                    userType,
                    jwtToken
                },
            });

            if (data?.sendVerificationSecureSms?.status === 200) {
                dispatch(setLoaderComplete('smsLoading'));
                dispatch(openHeaderModal('verifyPhoneNumber'));

                isResendOtp && await showToaster({ messageId: 'resendOtp', toasterType: 'success' });
                dispatch({
                    type: SEND_VERIFICATION_SMS_SUCCESS,
                });
            } else if (data?.sendVerificationSecureSms?.status === 400) {
                let errorMessage = data?.sendVerificationSecureSms?.errorMessage
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: errorMessage });
                dispatch({
                    type: SEND_VERIFICATION_SMS_ERROR,
                });
                dispatch(setLoaderComplete('smsLoading'));

            } else {
                let errorMessage = data?.sendVerificationSecureSms?.errorMessage
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: errorMessage});
                dispatch(setLoaderComplete('smsLoading'));
            }
        } catch (error) {
            dispatch({
                type: SEND_VERIFICATION_SMS_ERROR,
            });
            dispatch(setLoaderComplete('smsLoading'));
            return {
                status: '400'
            };
        }
        return {
            status: '200'
        };
    };
}